import React from "react";
import Header from "../components/Header";
import {link} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "../styles/Convu.css";

function ConvuConfirmation() {
  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/journey", label: "Our Journey" },
    { to: "/blog", label: "Blogs & Insights" },
    { to: "/get-in-touch", label: "Support" },

    // { to: "/chat", label: "Meet Sparky" }
  ];

  return (
    <>
      <Header links={navLinks} />

      <Helmet>
        <title>Thank You | Convu by DataPulse AI</title>
        <meta name="description" content="Join the waitlist for Convu - the future of genuine connection, powered by AI. Coming soon from DataPulse AI." />
        <link rel="canonical" href="https://www.mydatapulse.co.uk/convu" />
      </Helmet>

      <div className="page-container">
        <div>
          <img
            src="icons/convu-white-transparent.png"
            alt="Convu Logo"
            className="w-1/2 mx-auto"
          />
        </div>

        <br/>
        <h2 style={{ color: "#00b8db" }} className="subheading text-5xl md:text-xl">It's official. You're in 🥳</h2>
        <div className="form-container">
          <p className="subheading text-xl">Welcome to the Convu family</p>
          <br/>
          <p className="description text-lg">We’re cooking up something awesome.<br/><br/>You’re gonna be one of the first to see it. Keep an eye on your inbox 👀</p>
        </div>

        <div>
          <p className="description text-base">The future of communication - powered by AI, built for real connection.</p>
          <p className="footer-text text-sm mt-4">You're early. You're ahead. And we're just getting started.</p>
        </div>
      </div>
    </>
  );
}

export default ConvuConfirmation;
